import { getProductsByCategoryIdV2 } from '@/services/category';
import { event_view_item_list } from '@/utils/gtm';
import { useLocale } from 'next-intl';
import { useEffect, useMemo, useState } from 'react';
import { useSWRConfig } from 'swr';
import useSWRMutation from 'swr/mutation';

const useProducts = (data, key, isMulti) => {
  const locale = useLocale();
  const [active, setActive] = useState(0);
  const {
    trigger,
    data: tabProducts,
    isMutating,
  } = useSWRMutation(
    isMulti ? `/${key}/${active}/${locale}` : `/${key}/${locale}`,
    async () => {
      const products = await getProductsByCategoryIdV2({
        categoryId: Number(data?.value?.[active]?.id),
        pageSize: key === 'deals-slider' ? 20 : 16,
        locale,
      });
      if (active !== 0 && products?.data?.data?.products?.length > 0) {
        event_view_item_list(undefined, products?.data?.data?.products);
      }
      return products;
    },
    { populateCache: true }
  );

  const { cache } = useSWRConfig();
  useEffect(() => {
    const currentTabCache = cache.get(
      isMulti ? `/${key}/${active}/${locale}` : `/${key}/${locale}`
    );
    if (!currentTabCache) {
      trigger(active);
    }
  }, [active, trigger, cache, locale, key, isMulti]);

  const allProducts = useMemo(() => {
    const currentTabCache = cache.get(
      isMulti ? `/${key}/${active}/${locale}` : `/${key}/${locale}`
    );
    const displayedProducts =
      currentTabCache?.data?.data?.data?.products?.length > 0
        ? currentTabCache?.data?.data?.data?.products
        : tabProducts?.data?.data?.products?.length > 0
          ? tabProducts?.data?.data?.products
          : [];
    return displayedProducts;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, tabProducts?.data?.data?.products, cache, active, locale]);

  return { allProducts, locale, setActive, active, isMutating };
};

export default useProducts;
